import { Link } from "react-router-dom"

export default function Footer(): React.JSX.Element {
	const year = new Date().getFullYear()
	return (
		<footer className="border-t bg-muted/30">
			<div className="mx-auto flex max-w-6xl flex-col gap-4 px-4 py-10 text-sm text-muted-foreground sm:flex-row sm:items-center sm:justify-between">
				<p>© {year} Biosany. Todos los derechos reservados.</p>
				<nav className="flex gap-4">
					<Link to="/condiciones" className="hover:text-primary">
						Términos
					</Link>
					<Link to="/privacidad" className="hover:text-primary">
						Privacidad
					</Link>
					<Link to="/contacto" className="hover:text-primary">
						Contacto
					</Link>
				</nav>
			</div>
		</footer>
	)
}
